export function setupAnalytics() {
	const ga = window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
	window.ga = ga;
	ga( 'create', $defaConfig.googleAnalyticsTrackingCode, 'auto' );
	ga( 'require', 'autotrack' );
	ga( 'send', 'pageview' );
}